<template>
  <div>
    <!-- 公司简介 -->
    <div class="app">
      <!-- :style="{ background: 'url(' + require('@/assets/images/com_bg.png') + ') no-repeat center center'}" -->
      <div class="img">
        <img src="@/assets/images/introdution/ys.png" />
        <img src="@/assets/images/introdution/zx.png" />
      </div>

      <div class="intro">
        <h4>公司简介</h4>
        <div>
          <p class="first">
            武汉大晟极科技有限公司（以下简称大晟极）致力于声纹识别与语音智能技术研发，并结合视觉智能及
            大数据技术开发，是身份识别与音频大数据领域解决方案提供商。大晟极的技术发端于国防、公共安全相关
            语音智能应用，发展于民用身份识别安全应用领域，因此打造一家军民融合、人工智能领域的高科技企业，
            构建更加安全和便利的社会，是大晟极创立的初心。
          </p>
          <p
            class="first"
          >目前大晟极已开发出业界领先的声纹识别、智能音频处理与分析、声学拾音器产品系列，可广泛应用于国防、公共安全、智能安防、金融服务、移动互联网和智能物联网行业。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style scoped>
/* 简介开始 */
.app {
  position: relative;
}
.img :first-child {
  position: absolute;
  width: 399px;
  left: 100%;
  margin-left: -399px;
}
.img :nth-child(2) {
  position: absolute;
  width: 399px;
  left: 0px;
  margin-left: 0px;
  top: 100%;
  margin-top: -318px;
}
.intro {
  background-color: rgba(248, 248, 248, 1);
  height: 517px;
}
.intro div {
  width: 959px;
  position: absolute;
  left: 50%;
  margin-left: -490px;
}
h4 {
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  padding-top: 95px;
  padding-bottom: 57px;
}
.intro p {
  text-align: left;
  line-height: 40px;
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-top: 26px; */
}
.first {
  text-indent: 2em;
}
/* 简介结束*/
</style>



// WEBPACK FOOTER //
// src/components/common/introduction.vue